export const HeaderContentType = {
  JSON: 'application/json',
  IMG_PNG: 'image/png',
  URLENCODED: 'application/x-www-form-urlencoded',
}
